
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate-crypto",
      function () {
        return require("private-next-pages/donate-crypto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donate-crypto"])
      });
    }
  